export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-radar-line text-background-50 text-base"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                51吃瓜
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              全网最新最全的娱乐吃瓜资讯聚合平台。每日追踪娱乐圈、网红圈、社交平台的热门话题与最新动态，让吃瓜更简单。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-3">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '吃瓜速递', href: '#cards' },
                { label: '最新动态', href: '#updates' },
                { label: '热门排行', href: '#ranking' },
                { label: '吃瓜视频', href: '#media' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-3">更多内容</h4>
            <ul className="space-y-2">
              {[
                { label: '专题合集', href: '#index' },
                { label: '关于我们', href: '#about' },
                { label: '平台特色', href: '#features' },
                { label: 'APP下载', href: '#app' },
                { label: '联系我们', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-500">
              更多合作伙伴即将加入，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 51吃瓜app 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>安全访问</span>
            <span>隐私保护</span>
            <span>每日更新</span>
          </div>
        </div>
      </div>
    </footer>
  );
}